import axios from 'axios';
import { getToken } from './ServicioManejadorToken';
import { BASE_URL } from './ServicioConstantes';
import servicioObjetos from './ServicioObjetos';
var instanciaAxios = axios.create({
  baseURL: BASE_URL
});


//Se cambia la forma de agregar el spinner ya que no permitia que el monitor siga trabajando
//document.body.classList.add('loading-indicator');
//document.body.classList.add('loading-indicator');
//Asi es como estaba antes, se agregaba al body y ahora se agrega al ID=Monitor
instanciaAxios.interceptors.request.use(function (config) {
  return getToken(config).then(response => {
    let token = response;    
    if (token) {
      if (config.method !== 'OPTIONS') {
        let autorizacion = token;
        config.headers.Authorization = autorizacion;
      }
    }
    agregarClaseCargando();
    return Promise.resolve(config);
  })
}, function (error) {
  quitarClaseCargando();
  return Promise.reject(error);
});

instanciaAxios.interceptors.response.use(function (response) {
  quitarClaseCargando();
  return response;
}, function (error) {
  quitarClaseCargando();
  return getToken().then(response => {
    if (servicioObjetos.esObjetoVacio(response)) {
      if (error.config.url.includes('autenticar?usuario=')) {
        return Promise.reject(error);
      }
      else {
       window.location = "/idsenube";
      }
    } else {
      return Promise.reject(error);
    }
  });
});

function agregarClaseCargando(){
  let elementoMonitor=document.getElementById('monitor');
  if(undefined != elementoMonitor){
    elementoMonitor.classList.add('loading-indicator');
  }else{
    document.body.classList.add('loading-indicator');
  }
}

function quitarClaseCargando(){
  let elementoMonitor=document.getElementById('monitor');
  if(undefined != elementoMonitor){
    elementoMonitor.classList.remove('loading-indicator');
  }else{
    document.body.classList.remove('loading-indicator');
  }
}

export default instanciaAxios;